module.exports = __webpack_public_path__ + "img/cns_pc21.48315836.png";